/**
 * Изображение гифта.
 *
 * В макете здесь картинка, а у нас до сих пор была штриховка — не стиль, а
 * недоделка: мы просто нигде её не запрашивали. Человек выбирает гифт
 * глазами, и список одинаковых серых квадратов выбирать не помогает.
 *
 * Штриховка остаётся запасным вариантом: у части айтемов картинки нет, и
 * пустое место на её месте выглядело бы поломкой.
 */
export function GiftArt({
  image,
  size,
  radius = 12,
  full = false,
}: {
  image: string | null;
  size: number;
  radius?: number;
  /**
   * Во всю ширину карточки, квадратом.
   *
   * В сетке витрины ширину задаёт колонка, а не картинка. Квадрат — потому
   * что гифты рисуют квадратными: полоса в 96 пикселей высотой срезала бы
   * у них ровно то, ради чего человек и смотрит на карточку. `size` в этом
   * случае работает нижней границей — чтобы карточка не схлопнулась, пока
   * сетка не посчитана.
   */
  full?: boolean;
}) {
  return (
    <div
      className="thumb"
      style={{
        // Ширина задаётся явно, а не только flex-basis: вне строки-флексбокса
        // (например, по центру колонки) basis не действует вовсе, и картинка
        // схлопывалась в нулевую ширину. В карточке закрытой сделки от неё
        // оставалась одна вертикальная полоска рамки — «красивая» красная
        // линия вместо гифта.
        flex: full ? '0 0 auto' : `0 0 ${size}px`,
        width: full ? '100%' : size,
        // height здесь обязателен: у класса .thumb она своя, и без явного
        // auto пропорция не действует — картинка так и остаётся полосой.
        ...(full ? { height: 'auto', aspectRatio: '1 / 1', minHeight: size } : { height: size }),
        borderRadius: radius,
        padding: 0,
        ...(image === null
          ? {}
          : { backgroundImage: `url(${image})`, backgroundSize: 'cover', backgroundPosition: 'center' }),
      }}
    />
  );
}
